module.exports = __webpack_public_path__ + "img/sglt_h.7cc2f395.png";